module.exports = __webpack_public_path__ + "img/item-1.aa4f749.png";